import type { UploadLimits } from '@ai-content-hub/shared-config';

import type { UploadLimitsResponse } from '@/services/systemSettings.service';

function positiveOrNull(value: unknown): number | null {
    return typeof value === 'number' && Number.isFinite(value) && value > 0 ? value : null;
}

/**
 * EAA-1212: wire → seam. A missing or malformed field becomes `null`, which every
 * upload site reads as "keep your own constant" — a partial response never turns
 * into a 0MB cap.
 */
export function toUploadLimits(response: UploadLimitsResponse | undefined): UploadLimits | null {
    if (!response) return null;
    const extensions = response.media?.extensions;
    return {
        mediaMaxSizeMb: positiveOrNull(response.media?.max_size_mb),
        mediaExtensions: extensions
            ? {
                  image: extensions.image ?? [],
                  audio: extensions.audio ?? [],
                  video: extensions.video ?? [],
                  document: extensions.document ?? [],
              }
            : null,
        documentMaxSizeMb: positiveOrNull(response.document_max_size_mb),
        scormMaxSizeMb: positiveOrNull(response.scorm_max_size_mb),
        h5pMaxSizeMb: positiveOrNull(response.h5p_max_size_mb),
        moodleMaxSizeMb: positiveOrNull(response.moodle_max_size_mb),
        aiDocumentMaxSizeMb: positiveOrNull(response.ai_document_max_size_mb),
        model3dMaxSizeMb: positiveOrNull(response.model3d_max_size_mb),
        programDocumentMaxSizeMb: positiveOrNull(response.program_document_max_size_mb),
        importMaxFiles: positiveOrNull(response.import_max_files),
    };
}
